import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { FIREBASE_API } from 'src/config-global';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: FIREBASE_API.apiKey,
  authDomain: FIREBASE_API.authDomain,
  projectId: FIREBASE_API.projectId,
  storageBucket: FIREBASE_API.storageBucket,
  messagingSenderId: FIREBASE_API.messagingSenderId,
  appId: FIREBASE_API.appId,
};

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);
export const database = getDatabase(app, FIREBASE_API.realtimeDatabaseUrl);
export const firebaseStorage = getStorage(app);
